export function checkProtocol(url) {
	return /\b(http|https)/.test(url);
}
